import * as Sentry from "@sentry/react";
import { useEffect } from "react";
import {
  createBrowserRouter,
  createRoutesFromChildren, matchRoutes, useLocation, useNavigationType,
} from "react-router-dom";

const getSentryDsn = () => {
  if (process.env.NODE_ENV === "production") {
    return "https://4e6c807a9fa828c58da9fb87dd771bf1@o4508130513256448.ingest.de.sentry.io/4508130575384656";
  }

  return "https://00de685398375ad90c539226dab97265@o4508130513256448.ingest.de.sentry.io/4508718021410896";
};

Sentry.init({
  dsn: getSentryDsn(),
  environment: process.env.NODE_ENV,
  integrations: [
    // See docs for support of different versions of variation of react router
    // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
    Sentry.reactRouterV6BrowserTracingIntegration({
      createRoutesFromChildren,
      matchRoutes,
      useEffect,
      useLocation,
      useNavigationType,
    }),
    Sentry.breadcrumbsIntegration(),
  ],

  replaysOnErrorSampleRate: 0.0,
  replaysSessionSampleRate: 0.0,
  tracesSampleRate: 0.0,
  autoSessionTracking: false,
});

export const sentryCreateBrowserRouter = Sentry.wrapCreateBrowserRouter(
  createBrowserRouter,
);

export const createSentryErrorFromGraphQL = (gqlError, errorName = null) => {
  const errorTitle = errorName ?? (gqlError.message || "GraphQL error");
  const sentryError = new Error(errorTitle);
  sentryError.name = errorTitle;

  return sentryError;
};

export const logGqlErrorToSentry = (error, errorName = null, context = {}) => {
  Sentry.withScope((scope) => {
    scope.setExtras({
      graphql_extensions: JSON.stringify(error.extensions, null, 2),
      graphql_path: error.path,
      graphql_original_error: error.originalError,
      ...context,
    });

    Sentry.captureException(createSentryErrorFromGraphQL(error, errorName));
  });
};
